import React from 'react';
import PropTypes from 'prop-types';

export default function Boletins({ width, height }) {
  return (
    <svg width={width} height={height} viewBox="0 0 496 496">
      <path d="M475.299,106.918l-12.047-3.765c-3.012-0.753-6.024-1.506-9.788-1.506c-13.553,0-25.6,9.035-30.118,21.835l-6.776,20.329
				v-15.059V128c0-2.259-1.506-4.518-3.012-6.024L290.076,2.259C288.57,0.753,286.311,0,284.805,0H43.111
				c-4.518,0-7.529,3.012-7.529,7.529v23.341H7.723c-4.518,0-7.529,3.012-7.529,7.529v451.012c0,4.518,3.012,7.529,7.529,7.529
				h365.929c4.518,0,7.529-3.012,7.529-7.529v-23.341h27.859c4.518,0,7.529-3.012,7.529-7.529V356.894l21.082-28.612l0.753-2.259
				l56.471-179.953C500.899,129.506,491.864,112.188,475.299,106.918z M292.334,25.6l98.635,94.871h-98.635V25.6z M366.123,481.882
				H15.252V45.929h20.329v412.612c0,4.518,3.012,7.529,7.529,7.529h323.012V481.882z M402.264,451.012h-0.753H50.64V15.059h226.635
				V128c0,4.518,3.012,7.529,7.529,7.529h117.459V192l-35.388,111.435v2.259l1.506,95.624c0,3.012,2.259,6.024,5.271,6.776
				c3.012,0.753,6.776,0,8.282-3.012l20.329-27.106V451.012z M382.687,377.976l-1.506-62.494l37.647,12.047L382.687,377.976z
        M481.323,141.553l-54.212,172.424l-43.671-14.306L437.652,128c3.012-8.282,12.047-13.553,20.329-10.541l12.047,3.765
				C479.064,123.482,484.334,133.271,481.323,141.553z"/>
			<path d="M101.84,135.529h108.424c4.518,0,7.529-3.012,7.529-7.529V51.2c0-4.518-3.012-7.529-7.529-7.529H101.84
				c-4.518,0-7.529,3.012-7.529,7.529V128C94.311,131.765,98.076,135.529,101.84,135.529z M109.37,58.729h93.365v61.741H109.37
				V58.729z"/>
			<path d="M86.782,206.306h228.894c4.518,0,7.529-3.012,7.529-7.529c0-4.518-3.012-7.529-7.529-7.529H86.782
				c-4.518,0-7.529,3.012-7.529,7.529C79.252,203.294,82.264,206.306,86.782,206.306z"/>
			<path d="M86.782,261.271h228.894c4.518,0,7.529-3.012,7.529-7.529s-3.012-7.529-7.529-7.529H86.782
				c-4.518,0-7.529,3.012-7.529,7.529S82.264,261.271,86.782,261.271z"/>
			<path d="M86.782,316.235h228.894c4.518,0,7.529-3.012,7.529-7.529s-3.012-7.529-7.529-7.529H86.782
				c-4.518,0-7.529,3.012-7.529,7.529S82.264,316.235,86.782,316.235z"/>
			<path d="M322.452,363.671c0-4.518-3.012-7.529-7.529-7.529H86.782c-4.518,0-7.529,3.012-7.529,7.529s3.012,7.529,7.529,7.529
				h228.894C319.44,371.2,322.452,367.435,322.452,363.671z"/>
			<path d="M347.299,411.106H233.605c-4.518,0-7.529,3.012-7.529,7.529s3.012,7.529,7.529,7.529h112.941
				c4.518,0,7.529-3.012,7.529-7.529S351.064,411.106,347.299,411.106z"/>
    </svg>
  )
}

Boletins.propTypes = {
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired
}
